import React from "react";

function PortfolioPage() {
  return (
    <div>
      <h1>My Projects</h1>
      <p>Here are some of the projects I've worked on:</p>
      <ul>
        <li>
          <a href="[Link to Project]">[Project Name]</a>
          <p>[Short Project Description]</p>
        </li>
        <li>
          <a href="[Link to Project]">[Project Name]</a>
          <p>[Short Project Description]</p>
        </li>
        <li>
          <a href="[Link to Project]">[Project Name]</a>
          <p>[Short Project Description]</p>
        </li>
      </ul>
    </div>
  );
}

export default PortfolioPage;
